import { useIntl, UserCross } from '@capsicum/common';
import { Button, Image } from '@capsicum/common-web';
import styled from 'styled-components';

type DeleteAccountConfirmationProps = { close: () => void; onDeletePress: () => void };

export const DeleteAccountConfirmation = ({ close, onDeletePress }: DeleteAccountConfirmationProps) => {
	const { $t } = useIntl();

	return (
		<S.Container>
			<S.Content>
				<Image alt="delete-account" height={130} src={UserCross} width={150} />
				<S.Text3>{$t('settings.accountManagement.youAreGoingToDeleteYourAccount')}</S.Text3>
			</S.Content>
			<S.ButtonsContainer>
				<S.ButtonStyled
					color="brand"
					testID="settings-accountManagement-keepAccount-button"
					text={$t('settings.accountManagement.keepAccount')}
					onClick={close}
				/>
				<S.ButtonStyled
					color="neutral"
					testID="settings-accountManagement-deleteAccount-button"
					text={$t('settings.accountManagement.deleteAccount')}
					variant="text"
					onClick={onDeletePress}
				/>
			</S.ButtonsContainer>
		</S.Container>
	);
};

namespace S {
	export const Container = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.large};
	`;

	export const Content = styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.large};
	`;

	export const ConfirmationContainer = styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;

	export const ButtonsContainer = styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-top: ${({ theme }) => theme.spacings.xsmall};
		gap: ${({ theme }) => theme.spacings.small};

		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			padding-top: 0;
			align-items: normal;
			gap: ${({ theme }) => theme.spacings.xsmall};
		}
	`;

	export const Title = styled.span`
		${({ theme }) => theme.fonts.text.textTopBar}
	`;

	export const Text3 = styled.span`
		white-space: pre-line;
		text-align: center;
		${({ theme }) => theme.fonts.text.text3}
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const Bold = styled.span`
		${({ theme }) => theme.fonts.text.text1}
	`;

	export const Email = styled.a`
		${({ theme }) => theme.fonts.text.text3}
		color: ${({ theme }) => theme.colors.text.brand.enabled};
	`;

	export const ButtonStyled = styled(Button)`
		flex-direction: row;
	`;
}
